import { Component, computed, input } from '@angular/core';
import { MuiColor } from '../utility';


/**
 * @deprecated: Use `MuiListItemIcon` instead.
 */
@Component({
  selector: 'mui-icon-box',
  template: `
    <ng-content select="mui-icon, i[mui-icon]"></ng-content>
  `,
  styleUrl: './mui-icon-box.component.scss',
  standalone: true,
  host: {
    /* eslint-disable  @typescript-eslint/naming-convention */
    '[class]': 'classes()'
    /* eslint-enable  @typescript-eslint/naming-convention */
  }
})
export class MuiIconBox {
  color = input<MuiColor | null, string>(null, { transform: (val) => <MuiColor>val });

  protected classes = computed(() => {
    const classes = ['mui-icon-box'];
    if (this.color()) {
      classes.push(`mui-icon-box--${this.color()}`);
    }
    return classes.join(' ');
  });
}
